import React, { useState, useEffect, useRef } from 'react';

const FadeIn = ({ children, className = '', style }) => {
  const ref = useRef(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          if (ref.current) {
            observer.unobserve(ref.current);
          }
        }
      },
      { threshold: 0.15 }
    );

    if (ref.current) {
      observer.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        observer.unobserve(ref.current);
      }
    };
  }, []);

  return (
    <div
      ref={ref}
      style={style}
      className={`transition-opacity duration-[1000ms] ${isVisible ? 'opacity-100' : 'opacity-0'
        } ${className}`}
    >
      {children}
    </div>
  );
};

export default FadeIn;
